import { render, staticRenderFns } from "./pendentes.vue?vue&type=template&id=67e22e8d&"
import script from "./pendentes.vue?vue&type=script&lang=js&"
export * from "./pendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports